import { useParams } from 'react-router-dom'
import PageList from './components/PageList'
import PageBuilderEditor from './components/PageBuilderEditor'

const PageBuilder = () => {
    const params = useParams()

    if (params.pageId) {
        return <PageBuilderEditor pageId={params.pageId} />
    }

    return <PageList />
}

export default PageBuilder
